import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import useStackScreenOptions from '@src/hooks/useStackScreenOptions';
import AuthenticatedRootStack from '@src/navigation/AuthenticatedRootStack';
import TourFilterModal from '@src/screens/Modals/TourFilterModal';

import { WithModalStackParamList } from './types';

const Stack = createStackNavigator<WithModalStackParamList>();

const Component: React.FC = () => {
  const stackScreenOptions = useStackScreenOptions();

  return (
    <Stack.Navigator mode="modal" headerMode="none" initialRouteName="Root">
      <Stack.Screen name="Root" component={AuthenticatedRootStack} />
      <Stack.Screen
        name="TourFilterModal"
        component={TourFilterModal}
        options={stackScreenOptions}
      />
    </Stack.Navigator>
  );
};

Component.displayName = 'WithModalStack';

export default Component;
